import { ThemeCss } from "../../theme"

const reachUIDefaultStyles: Record<string, ThemeCss> = {
  tabs: _theme => ({
    '[data-orientation="vertical"]': {
      display: `flex`,
    },
  }),
  tabList: _theme => ({
    display: `flex`,
    '[aria-orientation="vertical"]': {
      flexDirection: `column`,
    },
  }),
  tab: _theme => ({
    display: "inline-block",
    border: "none",
    background: "none",
    color: "inherit",
    font: "inherit",
    cursor: "pointer",
    WebkitAppearance: "none",
    MozAppearance: "none",
  }),
}

const tabsCss: ThemeCss = theme => [reachUIDefaultStyles.tabs(theme)]

const tabsListCss: ThemeCss = theme => [
  reachUIDefaultStyles.tabList(theme),
  {
    display: `flex`,
    flexGrow: 1,
    flexShrink: 0,
    listStyleType: `none`,
    margin: 0,
    position: `relative`,
    overflowX: `auto`,
    WebkitOverflowScrolling: `touch`,
    "&::-webkit-scrollbar": {
      display: `none`,
    },
    // bottom border
    boxShadow: `inset 0 -1px 0 ${theme.colors.blackFade[10]}`,
  },
]

const tabCss: ThemeCss = theme => [
  reachUIDefaultStyles.tab(theme),
  {
    flexShrink: 0,
    margin: 0,
    padding: 0,
    position: `relative`,

    "&:not(:last-of-type)": {
      marginRight: theme.space[5],
    },
  },
]

const tabButtonCss: ThemeCss = theme => ({
  alignItems: `center`,
  display: `flex`,
  margin: 0,
  padding: `${theme.space[4]} ${theme.space[3]}`,
  position: `relative`,
  overflowY: `hidden`,
  color: theme.colors.grey[60],
  fontFamily: theme.fonts.system,
  fontSize: theme.fontSizes[2],
  background: `none`,
  border: `none`,
  cursor: `pointer`,

  "&:after": {
    borderRadius: theme.radii[1],
    bottom: 0,
    content: `""`,
    left: 0,
    height: `2.5px`,
    position: `absolute`,
    transition: `transform ${theme.transitions.speed.default}`,
    width: `100%`,
    background: theme.colors.purple[30],
    transform: `translateY(100%)`,
  },

  "&:hover": {
    "&:after": {
      transform: `translateY(0)`,
    },
  },
})

const tabButtonSelectedCss: ThemeCss = theme => ({
  fontWeight: theme.fontWeights.semiBold,
  color: theme.colors.grey[70],
  "&:after": {
    background: theme.colors.purple[40],
    transform: `translateY(0)`,
  },
})

export const tabsStyles = {
  tabs: tabsCss,
  tabList: tabsListCss,
  tab: tabCss,
  tabButton: tabButtonCss,
  tabButtonSelected: tabButtonSelectedCss,
}
